import React, { useEffect } from 'react'
import { editGreenMarkProjectData } from '../data/editGreenMarkProject.Data';
import FormCreator from '../../../components/Forms/FormCreator';
import { useState } from 'react';
import { useRef } from 'react';
import { useAddEditGMProjectMutation, useLazyGetGMAPGreenMarkProjectDetailsBySourceQuery } from '../../../app/services/GMAP/GreenMarkProjectApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { decryptAESID } from '../../../utils/Encryption';
import { setFieldParameter } from '../utils/setFieldParameters';
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from '../../../app/services/common/commonApi';
import { setAllDropDownField } from '../utils/dropdownUtils';
import { saveAs } from "file-saver";
import { Button } from 'react-bootstrap';
import Buttons from '../../../components/ui/button/Buttons';
import SwalAlert from '../../../services/swalService/SwalService';

const EditGreenMarkProject = () => {
  const greenMarkProjectRef = useRef();
  const [formdata, setFormData] = useState(editGreenMarkProjectData)
  const [getGMProjectAndCpdListbySource, { isSuccess: isSuccessGetGMProjectAndCpdListbySource, isLoading: isGetGMProjectAndCpdListbySource, data: getGMProjectAndCpdListbySourceData }] = useLazyGetGMAPGreenMarkProjectDetailsBySourceQuery();
  const [getAllDropdownData, { isLoading: getDropdownDataIsLoading, data: allDropDownResponse, isSuccess: getAllDropdownDataIsSuccess, }] = useLazyGetAllDropDownsForMemberDirectoryQuery();
  const [filePaths, setFilePaths] = useState({ endorsementAttachedFile: null, greenMarkCategoryFile: null })
  const [bcaCPDPoint, setBcaCPDPoint] = useState(0);
  const [getPDF] = useLazyGetPDFQuery();
  const [uploadPDF] = useUploadPDFMutation();
  const [saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload }] = useStoreBase64ImageMutation();
  const [addEditGMProject, { isSuccess: isSuccessGmProject, isLoading: isLoadingGmProject, data: AddEditGMProjectResponse }] = useAddEditGMProjectMutation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const editId = id ? decryptAESID(id, false) : 0
  const { success, error } = SwalAlert()

  useEffect(() => {
    getAllDropdownData();
    if (editId && state?.gmapmemberId && state?.source) {

      getGMProjectAndCpdListbySource({
        memberId: state.gmapmemberId,
        projectId: editId,
        source: state.source,
      });
    }
  }, [editId, state]);

  useEffect(() => {
    if (!getDropdownDataIsLoading && allDropDownResponse && getAllDropdownDataIsSuccess) {
      setAllDropDownField(allDropDownResponse);
    }
  }, [getDropdownDataIsLoading, allDropDownResponse, getAllDropdownDataIsSuccess])

  useEffect(() => {
    if (!isGetGMProjectAndCpdListbySource && isSuccessGetGMProjectAndCpdListbySource && getGMProjectAndCpdListbySourceData) {
      setFieldParameter(getGMProjectAndCpdListbySourceData);
    }
  }, [isGetGMProjectAndCpdListbySource, isSuccessGetGMProjectAndCpdListbySource, getGMProjectAndCpdListbySourceData]);

  const handleDownload = async (data, dataField) => {
    const type = dataField === "endorsementAttachedFile" ? "LetterofEndorsement" : dataField === "greenMarkCategoryFile" ? "GreenMarkCategoryFile" : "";
    const request = {
      type: type,
      fileName: filePaths[dataField],
    }
    const response = await getPDF(request);
    saveAs(response?.data?.fileData, response?.data?.fileName);
  }
  const formActionHandler = {
    DOWNLOAD: handleDownload,
  }

  const handleBack = () => {
    navigate(`/greenMarkProject`)
  }
  useEffect(() => {
    if (isSuccessGmProject && AddEditGMProjectResponse) {
      success("Updated Successfully!")
    }
  }, [isSuccessGmProject, AddEditGMProjectResponse]);

  const handleSubmit = () => {
    const formData = greenMarkProjectRef.current.getFormData();
    if (!formData) {
      return error("Please fill all mandatory fields.", "")
    }
    let request = {
      GreenProjectInformationId: editId,
      // GMAPMemberId:state?.memberId,
      Remarks: formData?.remarks || getGMProjectAndCpdListbySourceData?.remarks || null,
      ProjectName: formData?.projectName || getGMProjectAndCpdListbySourceData?.projectName || null,
      GreenMarkProjectNumber: formData?.greenMarkProjectNumber || getGMProjectAndCpdListbySourceData?.greenMarkProjectNumber || null,
      DateofLetterofAward: formData?.dateofLetterofAward || getGMProjectAndCpdListbySourceData?.dateofLetterofAward || null,
      AwardRatingId: getGMProjectAndCpdListbySourceData?.awardRating || formData?.awardRating?.value || null,
      GreenMarkCategoryId: getGMProjectAndCpdListbySourceData?.gmapGreenMarkCategoryId || formData?.gmapGreenMarkCategoryId?.value || null,
      DeveloperOrbuildingOwner: formData?.developerBuildingOwner || getGMProjectAndCpdListbySourceData?.developerBuildingOwner || null,
      DescribeRoleInProject: formData?.describeYourRoleintheProject || getGMProjectAndCpdListbySourceData?.describeYourRoleintheProject || null,
      ClientLetterOfEndorsement: filePaths?.endorsementAttachedFile || getGMProjectAndCpdListbySourceData?.endorsementAttachedFile || null,
      UploadGreenMarkCategory: filePaths?.greenMarkCategoryFile || getGMProjectAndCpdListbySourceData?.greenMarkCategoryFile || null
    }
    addEditGMProject(request)
  }

  const handleOnChangeFileUpload = async (dataField, data) => {
    let pathName = dataField === "endorsementAttachedFile" ? "LetterofEndorsement" : dataField === "greenMarkCategoryFile" ? "GreenMarkCategoryFile" : "";
    let formData = new FormData();
    formData.append("file", data)
    formData.append("storagePath", pathName);
    const response = await uploadPDF(formData).unwrap();
    if (response && response.fileName && response.fileName !== '') {
      setFilePaths({ ...filePaths, [dataField]: response.fileName })
    }
  }

  const setCpdPoint = (value) => {
    const CpdPointsIndex = editGreenMarkProjectData.formFields.findIndex(field => field.id === "CpdPoints");
    if (CpdPointsIndex !== -1) {
      const updatedFormData = { ...editGreenMarkProjectData };
      updatedFormData.initialState.CpdPoints = value?.Point;
      updatedFormData.formFields[CpdPointsIndex].fieldSetting.value = value?.Point;
    }
  }

  const handleOnChangeImageUpload = (data) => {
    const { base64Data, fileName } = data
    let saveFileRequest = {
      fileName: fileName,
      fileStr: base64Data,
      storagePath: "AcademincQualificationImage",
    }
    saveMainImage(saveFileRequest)
  }
  const handleFormFieldChange = (dataField, value) => {
    if ((dataField === "endorsementAttachedFile" || dataField === "greenMarkCategoryFile") && value) {
      if (value.type === "application/pdf") {
        handleOnChangeFileUpload(dataField, value);
      }
      else {
        handleOnChangeImageUpload(value);
      }
    }
    if ((dataField === "gmapGreenMarkCategoryId") && value) {
      setCpdPoint(value);
      setBcaCPDPoint(value?.Point);
    }
  };
  return (
    <div className='common-project-info-main'>
      <div className='row gx-5 horizontal-form'>
        <FormCreator
          ref={greenMarkProjectRef}
          {...formdata}
          onActionChange={formActionHandler}
          onFormFieldValueChange={handleFormFieldChange}
        />
        <div className='container'>
          <div className='row col-12 d-flex justify-content-between align-items-center'>
            <Buttons
              buttonTypeClassName="success-btn"
              buttonText="Back"
              onClick={handleBack}
            />
            {state.source === "GreenMarkInformation" && (
              <Buttons
                buttonTypeClassName="success-btn"
                buttonText="Save"
                onClick={handleSubmit}
              />
            )}
          </div>
        </div>
      </div>
    </div>

  )
}

export default EditGreenMarkProject